import CanShow from "./CanShow";
import Single from "@/features/messages/send/Single";
import Multiple from "@/features/messages/send/Multiple";
import Messages from "@/features/messages/messages/Index";
import Automated from "@/features/messages/automated/Index";
import AutomatedForm from "@/features/messages/automated/Form";
import AutomatedShow from "@/features/messages/automated/show/Index";
import SmsBalance from "@/features/messages/smsBalance/Index";

export const messagesRoutes = [
  {
    path: "/messages",
    element: <CanShow page={<Messages />} ifHas={["sendMessage"]} />,
  },
  {
    path: "/sms-balance",
    element: <CanShow page={<SmsBalance />} ifHas={["sendMessage"]} />,
  },
  {
    path: "/automated",
    element: <CanShow page={<Automated />} ifHas={["sendMessage"]} />,
  },
  {
    path: "/automated/create",
    element: <CanShow page={<AutomatedForm />} ifHas={["sendMessage"]} />,
  },
  {
    path: "/automated/:id",
    element: <CanShow page={<AutomatedShow />} ifHas={["sendMessage"]} />,
  },
  {
    path: "/automated/:edit/edit",
    element: <CanShow page={<AutomatedForm />} ifHas={["sendMessage"]} />,
  },

  {
    path: "/send-single",
    element: <CanShow page={<Single />} ifHas={["sendMessage"]} />,
  },
  {
    path: "/send-multiple",
    element: <CanShow page={<Multiple />} ifHas={["sendMessage"]} />,
  },
];
